export default "__VITE_ASSET__vaiYifvm__"